module.exports = __webpack_public_path__ + "static/media/hallWaiting.eb4ad958.png";